module.exports = __webpack_public_path__ + "static/pool-y-82389e66b20dfc2050985c594f65d8d8.svg";